import { render, staticRenderFns } from "./Sanctions.vue?vue&type=template&id=f9c1ef94"
import script from "./Sanctions.vue?vue&type=script&lang=js"
export * from "./Sanctions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports